import { ComponentType } from 'react';
import styled, { css } from 'styled-components';
import { InputProps, SingleValue, components } from 'react-select';
import { CommonSelectProps, SelectOption } from '../../types';
import { s8 } from '@ardoq/design-tokens';

const InputStylesProvider = styled.div<{ $hasLeftContent?: boolean }>`
  margin: 0;
  padding: 0;
  position: relative;

  & > div {
    margin: 0;
    padding: 0;
  }

  /* Overwriting global Bootstrap styles */
  && input {
    height: auto;
    box-shadow: none;
  }

  ${({ $hasLeftContent }) =>
    $hasLeftContent &&
    css`
      & > div {
        padding-left: ${s8};
      }
    `}
`;

export const INPUT_SELECTOR = InputStylesProvider.toString();

export const Input: ComponentType<
  InputProps<SelectOption<unknown>>
> = props => {
  const selectProps = props.selectProps as CommonSelectProps;
  const selectedOption = !props.isMulti
    ? (props.selectProps.value as SingleValue<SelectOption<unknown>>)
    : undefined;
  const genericIconName = selectProps.iconName;
  const hasLeftContent = Boolean(
    genericIconName ||
    selectedOption?.iconName ||
    selectedOption?.leftContent ||
    selectedOption?.leftIcon
  );

  return (
    <InputStylesProvider $hasLeftContent={hasLeftContent}>
      <components.Input
        {...props}
        data-click-id={selectProps.clickId}
        aria-describedby={`${selectProps.inputId}-value`}
        aria-disabled={selectProps.isDisabled}
        aria-readonly={selectProps.isReadOnly}
        aria-required={selectProps.isRequired}
      />
    </InputStylesProvider>
  );
};
